export interface IForm {
  questions: Array<IQuestion>;
  id: string;
  appId: string;
  title: string;
  description: string;
  createdAt: string;
  completedAt: string;
  archivedAt: string;
  embeddedSessionLocation: EmbeddedSessionLocationEnum;
}

export interface IQuestion {
  id: string;
  title: string;
  description: string;
  kind: QuestionKindEnum;
  isRequired: boolean;
  possibleAnswers: Array<IPossibleAnswer>;
  answeredAt?: string;
  answeredBy?: string;
  answer?: IAnswer | null;
  hasImage?: boolean;
}

export interface IYesNoAnswer {
  value: boolean;
  context?: string;
}

export enum QuestionKindEnum {
  YesNo = "YesNo",
  FreeTextSingleLine = "FreeTextSingleLine",
  FreeTextMultiLine = "FreeTextMultiLine",
  SingleSelect = "SingleSelect",
  MultiSelect = "MultiSelect",
  Number = "Number",
  Date = "Date",
}

export interface IAnswer {
  answeredAt?: string;
  context: string;
  value: AnswerValue;
}

export type AnswerValue = string | string[] | boolean | number | Date | null;

export interface IPossibleAnswer {
  isDefault?: boolean;
  value: boolean | string;
  text: string;
}

export enum EmbeddedSessionLocationEnum {
  AfterLogin = "AfterLogin",
  AfterProfile = "AfterProfile",
  AfterProviderSearch = "AfterProviderSearch",
  AfterAuthorizations = "AfterAuthorizations",
}
